export default "__VITE_PUBLIC_ASSET__fcf28c66__"